export default __webpack_public_path__ + "c8.png";